"use client";

import * as React from "react";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const interiorImages = [{
  src: "https://content-man.10web.cloud/wp-content/uploads/2026/03/Modern-and-soothing-beauty-salon-interior-1.png?v=n616zi1qqeq",
  caption: "The Reception Lounge"
}, {
  src: "https://content-man.10web.cloud/wp-content/uploads/2026/03/ChatGPT-Image-Mar-29-2026-09_53_32-AM.png?v=tp53tk3ybbq",
  caption: "Aesthetics Suite"
}, {
  src: "https://content-man.10web.cloud/wp-content/uploads/2026/03/ChatGPT-Image-Mar-29-2026-09_50_41-AM.png?v=x23lqj8lavb",
  caption: "Massage Sanctuary"
}, {
  src: "https://content-man.10web.cloud/wp-content/uploads/2026/03/ChatGPT-Image-Mar-29-2026-09_42_54-AM.png?v=mvxcjqbbc3",
  caption: "Clinical Excellence"
}];
export default function SanctuaryOfInk() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="132502" id="natalias-sanctuary" className="bg-background text-foreground w-full overflow-hidden py-24" ref={ref}>
      <div className={`transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="container mx-auto px-4 mb-12 md:mb-16 text-center">
          <h2 className="text-3xl md:text-5xl font-serif tracking-wide mb-4 text-foreground italic">
            Natalia&apos;s Sanctuary
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto font-sans text-sm md:text-base tracking-normal">
            Step into an ethereal space of clinical excellence and quiet luxury in the heart of Brooke.
          </p>
        </div>

        <div className="w-full relative">
          <Carousel opts={{
          align: "center",
          loop: true
        }} className="w-full">
            <CarouselContent className="-ml-0">
              {interiorImages.map((img, i) => <CarouselItem key={i} data-index={i} className="pl-0 basis-full md:basis-[90%] lg:basis-[85%] px-2 md:px-4">
                  <div className="relative overflow-hidden bg-muted rounded-3xl">
                    <AspectRatio ratio={21 / 9}>
                      <img src={img.src} alt={img.caption} className="object-cover w-full h-full contrast-110 brightness-105 hover:scale-105 transition-all duration-1000 ease-in-out" />
                      <div className="absolute bottom-4 right-4 md:bottom-8 md:right-8 bg-background/60 backdrop-blur-xl border border-border/30 px-4 py-2 md:px-6 md:py-3 shadow-sm rounded-full">
                        <span className="text-xs md:text-sm font-sans tracking-widest uppercase text-foreground">
                          {img.caption}
                        </span>
                      </div>
                    </AspectRatio>
                  </div>
                </CarouselItem>)}
            </CarouselContent>
            
            <div className="hidden md:block">
              <CarouselPrevious className="left-8 lg:left-16 bg-background/60 backdrop-blur-md border-border/30 hover:bg-secondary/80 text-foreground h-12 w-12 rounded-full transition-colors" />
              <CarouselNext className="right-8 lg:right-16 bg-background/60 backdrop-blur-md border-border/30 hover:bg-secondary/80 text-foreground h-12 w-12 rounded-full transition-colors" />
            </div>
          </Carousel>
        </div>
      </div>
    </section>;
}